export const subscriptionType = (isTrial) => (isTrial ? 'trial' : 'organic');

export const getPromotionTag = (isStudentPromotion, isHolidayPromotion) => {
  if (isStudentPromotion) {
    return 'student';
  }
  return isHolidayPromotion ? 'holiday' : 'none';
};

export default {
  subscriptionType,
  getPromotionTag
};
